export const MAP_ZOOM_RESOURCE_EVENT = 'c2:map-zoom-resource';

export interface MapZoomResourceDetail {
  resourceId: string;
  resourceName: string;
  latitude?: number;
  longitude?: number;
  offline?: boolean;
  status?: string;
}

export function dispatchMapZoomToResource(detail: MapZoomResourceDetail): void {
  window.dispatchEvent(new CustomEvent(MAP_ZOOM_RESOURCE_EVENT, { detail }));
}
